import { Component, Input } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

@Component({
	selector: "custom-form-toggle",
	template: `
		<div class="dynamic-field form-toggle" [attr.data-test]="'option-' + config.name" [formGroup]="group">
			<label [class.invalid]="hasRequiredTrueError">
				<toggle-button data-test="toggle" [formControlName]="config.name" />

				<ng-content select="h3" />
			</label>

			@if (hasRequiredTrueError) {
				<div class="error">
					{{ "general.errors.required_field" | translate }}
				</div>
			}
		</div>
	`,
	styleUrls: ["toggle.component.scss"],
	standalone: false,
})
export class FormToggleComponent {
	@Input() config: any;
	// @ts-expect-error TS2564
	@Input() group: UntypedFormGroup;

	get hasRequiredTrueError() {
		const control = this.group.get(this.config.name);
		// @ts-expect-error TS18047
		return control.touched && control.errors?.required;
	}
}
